export default __webpack_public_path__ + "static/trigove-284f0a923e6f5c1062961bab8370fd93.jpg";